import type { ImageSourcePropType } from "react-native";

export interface ProethicaPrinciple {
	title: string;
	description: string;
}

export interface ParsedProethicaPrinciple extends ProethicaPrinciple {
	body: string;
	guidingQuestions: string[];
}

type PrincipleAsset = {
	match: string;
	image: ImageSourcePropType;
	color: string;
	darkColor?: string;
};

export const PRINCIPLE_ASSETS: PrincipleAsset[] = [
	{
		match: "solution discovery",
		image: require("../../../assets/praxis-proethica/illustrations/principles/principle-01-promoting-solution-discovery-illustration-v2.png"),
		color: "#3F1259",
		darkColor: "#8E6BAD",
	},
	{
		match: "risk mitigation",
		image: require("../../../assets/praxis-proethica/illustrations/principles/principle-02-risk-mitigation-illustration-v2.png"),
		color: "#502A7A",
		darkColor: "#9A7BC8",
	},
	{
		match: "objectivity",
		image: require("../../../assets/praxis-proethica/illustrations/principles/principle-03-objectivity-neutrality-maintained-illustration-v3.png"),
		color: "#3D5096",
		darkColor: "#7A90D4",
	},
	{
		match: "student welfare",
		image: require("../../../assets/praxis-proethica/illustrations/principles/principle-04-ensuring-student-welfare-illustration-v2.png"),
		color: "#2A7A9A",
		darkColor: "#52B8D8",
	},
	{
		match: "transparency",
		image: require("../../../assets/praxis-proethica/illustrations/principles/principle-05-transparency-actions-communications-illustration-v2.png"),
		color: "#2A9670",
		darkColor: "#40D0A0",
	},
	{
		match: "boundaries",
		image: require("../../../assets/praxis-proethica/illustrations/principles/principle-06-boundaries-role-time-place-illustration-v2.png"),
		color: "#3A9638",
		darkColor: "#50C858",
	},
	{
		match: "integrity",
		image: require("../../../assets/praxis-proethica/illustrations/principles/principle-07-integrity-profession-illustration-v2.png"),
		color: "#6A9620",
		darkColor: "#88C848",
	},
	{
		match: "code of ethics",
		image: require("../../../assets/praxis-proethica/illustrations/principles/principle-08-code-ethics-fidelity-illustration-v2.png"),
		color: "#B08818",
		darkColor: "#D8B048",
	},
	{
		match: "stewardship",
		image: require("../../../assets/praxis-proethica/illustrations/principles/principle-09-stewardship-law-public-trust-illustration-v2.png"),
		color: "#D49210",
		darkColor: "#F0C050",
	},
];

export const getPrincipleAsset = (title: string, index: number) =>
	PRINCIPLE_ASSETS.find((asset) => title.toLowerCase().includes(asset.match)) ??
	PRINCIPLE_ASSETS[index % PRINCIPLE_ASSETS.length];

export const parsePrincipleDescription = (
	principle: ProethicaPrinciple,
): ParsedProethicaPrinciple => {
	const normalized = principle.description.replace(
		/(?:\*\*|#{2,4})\s*Guiding Questions\s*(?:\*\*)?/gi,
		"Guiding Questions",
	);
	const [body = "", questions = ""] = normalized.split(/Guiding Questions/i);

	return {
		...principle,
		body: body.trim(),
		guidingQuestions: questions
			.split("\n")
			.map((line) => line.trim().replace(/^-\s+/, ""))
			.filter(Boolean),
	};
};
